import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter  } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import history from './history'
//import mockServer from './mock'
import './locales';
import SuperTokens, { SuperTokensWrapper } from "supertokens-auth-react";
import {superTokensConfig} from "./configs/superTokensConfig";


function App() {
	SuperTokens.init(superTokensConfig);

	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<SuperTokensWrapper>
				<BrowserRouter history={history}>
					<Theme>
						<Layout />
					</Theme>
				</BrowserRouter >
				</SuperTokensWrapper>
			</PersistGate>
		</Provider>
	)
}

export default App
